/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Byte4Word,
    Byte4WordFromJSON,
    Byte4WordFromJSONTyped,
    Byte4WordToJSON,
} from './Byte4Word';

/**
 * 校正結果
 * @export
 * @interface Byte4Word200ResponseResultData
 */
export interface Byte4Word200ResponseResultData {
    /**
     * タイトルに含まれる校正結果のリスト
     * @type {Array<Byte4Word>}
     * @memberof Byte4Word200ResponseResultData
     */
    title?: Array<Byte4Word>;
    /**
     * サブタイトルに含まれる校正結果のリスト
     * @type {Array<Byte4Word>}
     * @memberof Byte4Word200ResponseResultData
     */
    subtitle?: Array<Byte4Word>;
    /**
     * リード文に含まれる校正結果のリスト
     * @type {Array<Byte4Word>}
     * @memberof Byte4Word200ResponseResultData
     */
    head?: Array<Byte4Word>;
    /**
     * 本文に含まれる校正結果のリスト
     * @type {Array<Byte4Word>}
     * @memberof Byte4Word200ResponseResultData
     */
    text?: Array<Byte4Word>;
    /**
     * キャプションに含まれる校正結果のリスト
     * @type {Array<Byte4Word>}
     * @memberof Byte4Word200ResponseResultData
     */
    caption?: Array<Byte4Word>;
}

export function Byte4Word200ResponseResultDataFromJSON(json: any): Byte4Word200ResponseResultData {
    return Byte4Word200ResponseResultDataFromJSONTyped(json, false);
}

export function Byte4Word200ResponseResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): Byte4Word200ResponseResultData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : ((json['title'] as Array<any>).map(Byte4WordFromJSON)),
        'subtitle': !exists(json, 'subtitle') ? undefined : ((json['subtitle'] as Array<any>).map(Byte4WordFromJSON)),
        'head': !exists(json, 'head') ? undefined : ((json['head'] as Array<any>).map(Byte4WordFromJSON)),
        'text': !exists(json, 'text') ? undefined : ((json['text'] as Array<any>).map(Byte4WordFromJSON)),
        'caption': !exists(json, 'caption') ? undefined : ((json['caption'] as Array<any>).map(Byte4WordFromJSON)),
    };
}

export function Byte4Word200ResponseResultDataToJSON(value?: Byte4Word200ResponseResultData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title === undefined ? undefined : ((value.title as Array<any>).map(Byte4WordToJSON)),
        'subtitle': value.subtitle === undefined ? undefined : ((value.subtitle as Array<any>).map(Byte4WordToJSON)),
        'head': value.head === undefined ? undefined : ((value.head as Array<any>).map(Byte4WordToJSON)),
        'text': value.text === undefined ? undefined : ((value.text as Array<any>).map(Byte4WordToJSON)),
        'caption': value.caption === undefined ? undefined : ((value.caption as Array<any>).map(Byte4WordToJSON)),
    };
}

